import { useState } from "react";
import "./StaticCardComponent.css";

const StaticCardComponent = ({ imgSrc, title, text }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className='col'>
            <div className='card border-0'>
                <img src={imgSrc} className="card-img-top" alt="..." />
                <div style={{ paddingLeft: '0', paddingRight: '0', paddingBottom: '0', textAlign: 'justify'}} className='card-body service-card-body'>
                    <h5 className='card-title card-title-font'>{title}</h5>
                    <p className="card-text card-text-font" style={{ display: 'inline' }}>
                        {isExpanded ? text : `${text.slice(0, 100)}... `}
                        <button 
                            className={`static-btn ml-2`} 
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? <span style={{ marginLeft: '8px' }}>See Less</span> : "See More"}
                        </button>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default StaticCardComponent;